module.exports = __webpack_public_path__ + "img/gPay-Payment.da172497.svg";